var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('Header'),_c('About'),_c('Ration'),_c('Potential'),_c('Advantage'),_c('Reviews'),_c('Form'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }